import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Slider from 'react-slick';
import Branded from '../components/Branded';
import SEO from '../components/SEO';
import ExternalLink from '../sections/ExternalLink';
import Footer from '../sections/Footer';
import styled, { keyframes } from 'styled-components';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Hero Banner ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const HeroBanner = styled.section`
  position: relative;
  height: 70vh;
  min-height: 480px;
  overflow: hidden;
  background: #0b1f3a;

  img.hero-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(11, 31, 58, 0.92) 0%,
      rgba(11, 31, 58, 0.82) 100%
    );
    z-index: 1;
  }

  .hero-content {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 24px;
  }

  .hero-title {
    font-size: clamp(1.8rem, 4vw, 3rem);
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    line-height: 1.25;
    max-width: 700px;
    margin: 0;
    animation: ${fadeUp} 0.8s ease 0.2s both;
  }

  .hero-title-highlight {
    font-size: clamp(1.8rem, 4vw, 3rem);
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    line-height: 1.25;
    max-width: 700px;
    margin: 0;
    animation: ${fadeUp} 0.8s ease 0.4s both;

    span {
      color: #f08020;
      font-style: italic;
    }
  }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Intro Section ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Content Blocks ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const BlocksSection = styled.section`
  background: #f2f6fc;
`;

const Block = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 48px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 48px 24px;
  }

  /* Even blocks: image right, text left */
  &:nth-child(even) {
    .block-image {
      order: 2;

      @media (max-width: 900px) {
        order: 1;
      }
    }
    .block-content {
      order: 1;

      @media (max-width: 900px) {
        order: 2;
      }
    }
  }

  & + & {
    padding-top: 0;
  }

  .block-image {
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      min-height: 400px;
    }

    @media (max-width: 900px) {
      img {
        min-height: 280px;
      }
    }
  }

  .block-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 48px 64px;

    @media (max-width: 1200px) {
      padding: 40px 48px;
    }

    @media (max-width: 900px) {
      padding: 36px 8px;
    }
  }

  .block-title {
    font-size: clamp(1.5rem, 2.4vw, 2rem);
    font-weight: 700;
    color: #111;
    line-height: 1.35;
    margin-bottom: 28px;
  }

  .block-desc {
    font-size: 14.5px;
    color: #1b2733;
    line-height: 2;
    white-space: pre-line;
  }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Vision & Mission ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const VisionMissionSection = styled.section`
  position: relative;
  overflow: hidden;

  .vm-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .vm-overlay {
    position: absolute;
    inset: 0;
    /* Lighter brand blue, matching the homepage CTA banner overlay */
    background: linear-gradient(
      180deg,
      rgba(19, 120, 229, 0.92) 0%,
      rgba(19, 120, 229, 0.78) 100%
    );
  }

  .vm-inner {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 1000px;
    margin: 0 auto;
    padding: 80px 48px;
    gap: 64px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      padding: 56px 24px;
      gap: 48px;
    }
  }

  .vm-card {
    text-align: center;
  }

  .vm-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 20px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .vm-title {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #f08020;
    margin-bottom: 20px;
  }

  .vm-desc {
    /* Blue on blue would vanish — keep the orange half, whiten the blue half */
    .brand-space {
      color: #fff;
    }

    font-size: 16px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.9;
  }
`;

/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Team Section ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */
const TeamSectionWrapper = styled.section`
  background: #fff;
  padding: 80px 0;
  border-bottom: 1px solid #d8e1ec;

  @media (max-width: 768px) {
    padding: 56px 0;
  }

  .team-inner {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .team-title {
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 700;
    color: #111;
    margin-bottom: 40px;
  }

  .team-slider {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px;

    .slick-list {
      margin: 0 -16px;
      padding: 12px 0 20px;
    }

    .slick-slide > div {
      padding: 0 16px;
    }

    .slick-prev,
    .slick-next {
      display: none !important;
    }

    .slick-dots {
      bottom: -40px;

      li button:before {
        font-size: 8px;
        color: #f08020;
      }
      li.slick-active button:before {
        color: #f08020;
      }
    }
  }

  .slide-card {
    outline: none;
    background: #fff;
    border: 1px solid #d8e1ec;
    border-radius: 8px;
    padding: 16px;
    transition: transform 0.3s ease, box-shadow 0.3s ease,
      border-color 0.3s ease;
  }

  .slide-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 44px rgba(19, 120, 229, 0.08);
    border-color: #1378e5;
  }

  .slide-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: block;
    margin-bottom: 16px;
    background: #f2f6fc;
  }

  .slide-title {
    font-size: 15px;
    font-weight: 700;
    color: #1b2733;
    margin-bottom: 4px;
  }

  .slide-subtitle {
    font-size: 12px;
    font-weight: 500;
    color: #f08020;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .slide-desc {
    font-size: 13px;
    font-weight: 300;
    color: #5b6b7c;
    line-height: 1.8;
  }
`;

const aboutQuery = graphql`
  {
    sanityAboutPage {
      heroImage {
        asset {
          _id
          url
        }
      }
      heroTitle
      heroTitleHighlight
      contentBlocks {
        _key
        title
        description
        image {
          asset {
            _id
            url
          }
        }
      }
      seoTitle
      seoDescription
    }
    sanityTeamSection {
      sectionTitle
      members {
        _key
        image {
          asset {
            _id
            url
          }
        }
        name
        position
        department
        title
        description
      }
      departments {
        _key
        image {
          asset {
            _id
            url
          }
        }
        name
        description
      }
    }
    sanityExternalLinkSection {
      sectionTag
      sectionTitle
      description
      image {
        asset {
          _id
          url
        }
      }
      ctaLabel
      url
    }
    sanityVisionMission {
      backgroundImage {
        asset {
          _id
          url
        }
      }
      visionTitle
      visionDescription
      missionTitle
      missionDescription
    }
  }
`;

export default function AboutPage() {
  const data = useStaticQuery(aboutQuery);
  const page = data?.sanityAboutPage;
  const team = data?.sanityTeamSection;
  const vm = data?.sanityVisionMission;
  const extLink = data?.sanityExternalLinkSection;

  return (
    <div>
      <SEO
        title={page?.seoTitle || 'About Us - Decorzo Space'}
        description={page?.seoDescription}
      />

      {/* Hero */}
      <HeroBanner>
        {page?.heroImage?.asset?.url && (
          <img
            className="hero-img"
            src={page.heroImage.asset.url + '?w=1920&auto=format'}
            alt={page?.heroTitle || 'About us'}
          />
        )}
        <div className="hero-overlay" />
        <div className="hero-content">
          {page?.heroTitle && <h1 className="hero-title">{page.heroTitle}</h1>}
          {page?.heroTitleHighlight && (
            <p className="hero-title-highlight">
              <span>{page.heroTitleHighlight}</span>
            </p>
          )}
        </div>
      </HeroBanner>

      {/* Content Blocks */}
      {page?.contentBlocks?.length > 0 && (
        <BlocksSection>
          {page.contentBlocks.map((block, idx) => (
            <Block key={block._key} $alt={idx % 2 !== 0}>
              <div className="block-image">
                {block.image?.asset?.url && (
                  <img
                    src={block.image.asset.url + '?w=1000&auto=format'}
                    alt={block.title || ''}
                    loading="lazy"
                  />
                )}
              </div>
              <div className="block-content">
                <Branded as="h3" className="block-title" text={block.title} />
                <Branded
                  as="p"
                  className="block-desc"
                  text={block.description}
                />
              </div>
            </Block>
          ))}
        </BlocksSection>
      )}

      {/* Featured external link */}
      <ExternalLink
        sectionTag={extLink?.sectionTag}
        sectionTitle={extLink?.sectionTitle}
        description={extLink?.description}
        image={extLink?.image}
        ctaLabel={extLink?.ctaLabel}
        url={extLink?.url}
      />

      {/* Vision & Mission */}
      {(vm?.visionDescription || vm?.missionDescription) && (
        <VisionMissionSection>
          {vm?.backgroundImage?.asset?.url && (
            <img
              className="vm-bg"
              src={vm.backgroundImage.asset.url + '?w=1920&auto=format'}
              alt=""
            />
          )}
          <div className="vm-overlay" />
          <div className="vm-inner">
            {vm?.visionDescription && (
              <div className="vm-card">
                <div className="vm-icon">
                  <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="32"
                      cy="32"
                      r="12"
                      stroke="#F08020"
                      strokeWidth="2.5"
                    />
                    <circle cx="32" cy="32" r="5" fill="#F08020" />
                    <path
                      d="M4 32c0 0 12-20 28-20s28 20 28 20-12 20-28 20S4 32 4 32z"
                      stroke="#F08020"
                      strokeWidth="2.5"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="vm-title">{vm.visionTitle || 'Vision'}</h3>
                <Branded
                  as="p"
                  className="vm-desc"
                  text={vm.visionDescription}
                />
              </div>
            )}
            {vm?.missionDescription && (
              <div className="vm-card">
                <div className="vm-icon">
                  <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="32"
                      cy="32"
                      r="28"
                      stroke="#F08020"
                      strokeWidth="2.5"
                    />
                    <circle
                      cx="32"
                      cy="32"
                      r="18"
                      stroke="#F08020"
                      strokeWidth="2.5"
                    />
                    <circle
                      cx="32"
                      cy="32"
                      r="8"
                      stroke="#F08020"
                      strokeWidth="2.5"
                    />
                    <circle cx="32" cy="32" r="3" fill="#F08020" />
                  </svg>
                </div>
                <h3 className="vm-title">{vm.missionTitle || 'Mission'}</h3>
                <Branded
                  as="p"
                  className="vm-desc"
                  text={vm.missionDescription}
                />
              </div>
            )}
          </div>
        </VisionMissionSection>
      )}

      {/* Meet Our Team */}
      {(team?.members?.length > 0 || team?.departments?.length > 0) &&
        (() => {
          const slides = [
            ...(team?.members || []).map(m => ({
              key: m._key,
              img: m.image?.asset?.url,
              title: m.title || m.name,
              subtitle: [m.position, m.department]
                .filter(Boolean)
                .join(' Ãƒâ€šÃ‚Â· '),
              desc: m.description,
              alt: m.name || m.title || '',
            })),
            ...(team?.departments || []).map(d => ({
              key: d._key,
              img: d.image?.asset?.url,
              title: d.name,
              subtitle: '',
              desc: d.description,
              alt: d.name || '',
            })),
          ];
          return (
            <TeamSectionWrapper>
              <div className="team-inner">
                <h2 className="team-title">
                  {team?.sectionTitle || 'Meet our talented team'}
                </h2>
              </div>
              <Slider
                className="team-slider"
                dots
                arrows={false}
                infinite={slides.length > 2}
                speed={500}
                slidesToShow={Math.min(slides.length, 2)}
                slidesToScroll={1}
                responsive={[
                  { breakpoint: 640, settings: { slidesToShow: 1 } },
                ]}
              >
                {slides.map(s => (
                  <div key={s.key} className="slide-card">
                    {s.img && (
                      <img
                        className="slide-img"
                        src={s.img + '?w=800&auto=format'}
                        alt={s.alt}
                        loading="lazy"
                      />
                    )}
                    <Branded as="h3" className="slide-title" text={s.title} />
                    <Branded
                      as="p"
                      className="slide-subtitle"
                      text={s.subtitle}
                    />
                    <Branded as="p" className="slide-desc" text={s.desc} />
                  </div>
                ))}
              </Slider>
            </TeamSectionWrapper>
          );
        })()}

      <Footer />
    </div>
  );
}
